import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { PointsIcon, SettingIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/points-management')({
  loader: ({ context }) => {
    context.groupLabel = 'pointManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'pointManagement.sidebar.menu.pointsConfiguration',
        label: 'Points Configuration',
        path: '/points-management/points-configuration',
        meta: {
          group: 'account.sidebar.title',
        },
        icon: SettingIcon,
      },
      {
        id: 'pointManagement.sidebar.menu.pointsTransfer',
        label: 'Points Transfer',
        path: '/points-management/points-transfer',
        icon: PointsIcon,
      },
      {
        id: 'pointManagement.sidebar.menu.systemTransfer',
        label: 'System Transfer',
        path: '/points-management/system-transfer',
        icon: PointsIcon,
      },
      {
        id: 'pointManagement.sidebar.menu.pointsRequest',
        label: 'Points Request',
        path: '/points-management/points-request',
        icon: PointsIcon,
      },
      {
        id: 'pointManagement.sidebar.menu.pointsBalanceStatement',
        label: 'Points Balance Statement',
        path: '/points-management/points-balance-statement',
        icon: PointsIcon,
      },
    ];
    return {
      crumb: <CrumbTitle id="pointManagement.sidebar.title" icon={PointsIcon} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
